/**
 * Normalizes a rejection value into the statusMessages value reported with a failed
 * "save project" analytics event. Non-Error rejections without a usable message are
 * reported as undefined so the tag falls back to an empty statusMessages.
 *
 * An array of rejection reasons (e.g. every rejected result of a Promise.allSettled)
 * is flattened into a single message so no failure is dropped from the event.
 */
export const getSaveStatusMessage = (error: unknown): string | undefined => {
  if (Array.isArray(error)) {
    const messages = error.map(getSaveStatusMessage).filter(Boolean);
    return messages.length ? messages.join('; ') : undefined;
  }

  if (error instanceof Error) {
    return error.message || undefined;
  }

  if (typeof error === 'string') {
    return error || undefined;
  }

  return undefined;
};
